import Ready from '@/utils/ready';
import stickybits from 'stickybits';
const selector = '[data-stickybits]';

(() => {
  Ready.watch(selector, (element: HTMLElement) => {
    stickybits(element);
  });
})();
